import React from 'react';
import { colors, fontFamily, fontSizes, fontWeights } from '../../theme/tokens';
import { SITE } from '../../config/siteContent';

// Notice strip above the public header on the landing page; the text bounces between the left and right edges.
// The outer track slides by the full strip width while the text slides back by its own width, so the
// text travels exactly from edge to edge (and on narrow screens pans to reveal the full line).
const AnnouncementTicker = () => {
  if (!SITE.announcement) return null;
  return (
    <div role="note" aria-label={SITE.announcement} style={{ background: colors.white, overflow: 'hidden', fontFamily, position: 'relative', zIndex: 51, marginBottom: -10 }}>
      <div className="vk-ticker-track" aria-hidden="true">
        <div
          className="vk-ticker-text"
          style={{
            display: 'inline-block', whiteSpace: 'nowrap', padding: '6px 0 0', lineHeight: 1.2, color: colors.navy,
            fontSize: fontSizes.body, fontWeight: fontWeights.semibold,
          }}
        >
          {SITE.announcement}
        </div>
      </div>
      <style>{`
        .vk-ticker-track { width: 100%; animation: vkTrack 11s ease-in-out infinite alternate; }
        .vk-ticker-text { animation: vkText 11s ease-in-out infinite alternate; }
        @keyframes vkTrack { from { transform: translateX(0); } to { transform: translateX(100%); } }
        @keyframes vkText { from { transform: translateX(0); } to { transform: translateX(-100%); } }
        @media (prefers-reduced-motion: reduce) {
          .vk-ticker-track, .vk-ticker-text { animation: none; }
          .vk-ticker-text { white-space: normal !important; padding-left: 16px !important; }
        }
      `}</style>
    </div>
  );
};

export default AnnouncementTicker;
